export default "__VITE_ASSET__C9IaO3cC__"